import { DEFAULT_ROUTE_QUALITY_SETTINGS, type RouteQualitySettings } from '@/lib/routePlanning';

/**
 * A tervező pontja és beállításai — KÜLÖN modulban (#79).
 *
 * ⚠️ Korábban a `RoutePlannerSheet.tsx` exportálta őket. A Geri-tár
 * (`store/assistantStore.ts`) innen veszi az alapértéket, a tervezőlap pedig a
 * tárat importálja — a komponensből olvasva ez KÖRKÖRÖS import volt, és
 * fejlesztői újratöltéskor „Cannot access 'DEFAULT_PLANNER_SETTINGS' before
 * initialization” hibát dobott (élesben csak a betöltési sorrend mentette meg).
 */

export interface PlannerPoint {
  lat: number;
  lng: number;
  /** A találat címkéje, ha kereséssel jött. NEM tároljuk el sehova. */
  label?: string;
}

export interface PlannerSettings extends RouteQualitySettings {
  mode: 'loop' | 'direct';
  detour: 'small' | 'medium' | 'large';
}

export const DEFAULT_PLANNER_SETTINGS: PlannerSettings = {
  mode: 'loop',
  detour: 'medium',
  ...DEFAULT_ROUTE_QUALITY_SETTINGS,
};
